import { useIsMobile } from '../../hooks/hooks';

import '../../common/css/style.css';

const PHONE_1 = '+380993800194';
const PHONE_2 = '+380669585763';
const INSTAGRAM = 'https://www.instagram.com/mriya_st_kyiv';
const FACEBOOK = 'https://www.facebook.com/profile.php?id=61583788163622';

export const Contacts = () => {
  const isMobile = useIsMobile();

  return (
    <div id="contacts" className="main-style">
      <div className="contacts-wrapper">
        <section className="location-wrapper">
          <h2 className="address-title">Наша адреса: м.Київ, Голосіївська 13а</h2>

          <div className="map-container">
            <iframe
              title="локація студії"
              src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2543.2476233264706!2d30.518986499999997!3d50.399222599999995!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x40d4cf4add6377bb%3A0x4fe695aa7bb77f89!2z0LLRg9C70LjRhtGPINCT0L7Qu9C-0YHRltGX0LLRgdGM0LrQsCwgMTPQkCwg0JrQuNGX0LIsIDAzMDM5!5e0!3m2!1suk!2sua!4v1760476878292!5m2!1suk!2sua"
              loading="lazy"
              allowFullScreen
              referrerPolicy="no-referrer-when-downgrade"
            />
          </div>
        </section>
        <section className="media-wrapper">
          <div className="link-wrapper">
            Телефони:
            <a href={`tel:${PHONE_1}`}>
              {` ${PHONE_1}`}
            </a>
            ,
            <a href={`tel:${PHONE_2}`}>
              {` ${PHONE_2}`}
            </a>
          </div>
          <div className="link-wrapper">
            <p>Instagram: {' '}
              <a href={INSTAGRAM}>Хореографічна студія "Мрія"(instagram)</a>
            </p>
          </div>
          <div className="link-wrapper">
            <p>Facebook: {' '}
              <a href={FACEBOOK}>Хореографічна студія "Мрія"(facebook)</a>
            </p>
          </div>
        </section>
      </div>

      {!isMobile && (
        <div className="contacts-text-container">
          <h2>Чекаємо на тренуваннях!:)</h2>
        </div>
      )}
    </div>
  );
};
